// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let InstrumentBalancer = function (inst)
{
    this.instrument = inst;
    this.prices = new Array();
    this.accountListPrices = new Object();
    this.AmountPosition = 0;
    this.AveragePositionPrice = 0.0;
    this.TotalPositionAmount = 0;
    this.OrderAmount = 0;
    this.TotalProfitLoss = 0;


    this.AccountTotalPositionAmount = new Object();
    this.AccountPositionPriceMultiplyAmountBuy = new Object();
    this.AccountPositionPriceMultiplyAmountSell = new Object();
    this.AccountPositionAmountBuy = new Object();
    this.AccountPositionAmountSell = new Object();
    this.AccountTotalProfitLoss = new Object();
}

InstrumentBalancer.prototype.Add = function (pos)
{
    if (pos != null)
    {
        this.prices.push(pos.Price);

        if (pos.Account != null && pos.Account.AcctNumber)
        {
            let accPrices = new Array();
            if (this.accountListPrices[pos.Account.AcctNumber] != null && Array.isArray(this.accountListPrices[pos.Account.AcctNumber]))
                accPrices = this.accountListPrices[pos.Account.AcctNumber];
            else
                this.accountListPrices[pos.Account.AcctNumber] = accPrices;

            accPrices.push(pos.Price);
        }
    }
}

InstrumentBalancer.prototype.GetAveragePositionPrice = function ()
{
    this.AveragePositionPrice = 0.0;
    for (let i = 0, len = this.prices.length; i < len; i++)
        this.AveragePositionPrice += this.prices[i];
    if (this.prices.length > 0)
        this.AveragePositionPrice /= this.prices.length;
    return this.AveragePositionPrice;
}

/// <summary>
/// 
/// </summary>
InstrumentBalancer.prototype.GetAveragePositionPriceByAccount = function ()
{
    //    foreach (string key in accountListPrices.Keys)
    //    {
    //        if (accountListPrices[key] is List<double>)
    //    {
    //            List<double> prices = (List<double>)accountListPrices[key];
    //    double AveragePositionPrice = 0.0D;
    //    foreach (double d in prices)
    //        AveragePositionPrice += d;
    //    AveragePositionPrice /= prices.Count;
    //    AccountAveragePositionPrice[key] = AveragePositionPrice;
    //}
    //}

    //return AccountAveragePositionPrice;
    return new Object();
}

export let UserBalancer = function (account)
{
    this.AssetBalances = {};//new Dictionary<string, UserBalancesAssetBalanceFields>();

    this.Profit = 0;
    this.ProfitNet = 0;
    this.ProfitForMargin = 0;
    this.ProfitForUnsettled = 0;
    this.OnlyProfitForWithdrawalAvailable = 0;
    this.LossForUnsettled = 0;

    // Валюта сервера
    this.ProfitBase = 0;
    this.ProfitNetBase = 0;

    this.OpenPosAmount = 0.0;
    this.OpenOrdAmount = 0.0;

    this.DictPosInstrVal = {};//new Dictionary<IInstrument, double>();

    this.OpenPosNumber = 0;
    this.OpenOrdNumber = 0;
    this.OpenPosExposition = 0.0;
    this.CurrMargin = 0.0;

    this.averagePositionPrice = 0;
    this.totalPositionAmount = 0;
    this.NotIsOptionCount = 0;


    this.MarginWarning = 0.0;
    this.StopOut = 0.0;
    this.WithdrawalAvailable = 0.0;

    this.BlockedForStocksAccountCurrency = 0.0;
    this.BlockedForStocks = 0.0;

    this.StockValue = 0;

    this.OptionValue = 0;
    this.OptionPremium = 0;
    this.Account = account;

    this.positions = [];
}

export let UserBalancesAssetBalanceFields = function ()
{
    this.OpenOrdAmount = 0;
    this.OpenPosAmount = 0;
    this.OpenPosNumber = 0;
    this.OpenOrdNumber = 0;
}